import {
  Box,
  FormControl,
  MenuItem,
  Pagination,
  PaginationProps,
  Select,
  SelectChangeEvent,
  styled,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const PaginationWrapperTxt = styled(Box)`
  .dashboardFooter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 8px 0 25px;
  }
  .dashboardFooterEntries {
    display: flex;
    align-items: center;
    max-width: 239px;
    flex-basis: 239px;
  }
  .dashboardFooterEntries p {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #121d32;
    display: flex;
    margin: 0;
  }
  .dashboardFooterEntries select {
    margin: 0 8px;
    width: 56px;
    border-radius: 8px;
    height: auto;
    padding: 5px 10px;
  }
  .MuiPaginationItem-root {
    width: 32px;
    height: 34px;
    background: #f1f1f1;
    border-radius: 2px;
    margin: 0 2px;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.2;
    color: #8d99ae;
    @media (max-width: 575px) {
      min-width: 25px;
      height: 25px;
    }
  }
  .Mui-selected {
    background: #d90429 !important;
    color: #fff !important;
  }
`;

const BottomEntriesPagination = styled(Stack)`
  justify-content: space-between;
  padding: 20px 0;
  @media (max-width: 600px) {
    justify-content: center;
    padding: 10px 0;
    flex-wrap: wrap;
  }
`;

const NoOfPageShwo = styled(Stack)`
  align-items: center;
  gap: 8px;
  position: relative;
  @media (max-width: 767px) {
    margin: 0 0 10px;
  }

  .MuiTypography-caption {
    font-size: 12px;
    color: #170f49;
  }
  .MuiInputBase-formControl {
    svg {
      display: none;
    }
  }
  .MuiSelect-select {
    min-height: 1px !important;
    padding: 8px 32px 8px 16px;
    font-size: 12px;
    border: 1px solid #e0e7ed;
  }

  .MuiOutlinedInput-notchedOutline {
    display: none;
  }
  .selectArrow {
    position: absolute;
    top: 0;
    left: 30%;
    transform: translate(0%, 50%);
    line-height: 0;
    z-index: -9;
    svg {
      color: #8d99ae;
      font-size: 18px;
    }
  }
`;

const PaginationSec = styled(Box)`
  .MuiPagination-ul {
    .MuiPaginationItem-root {
      background-color: #e5e5e6;
      border: none;
      color: #90a0b7;
      font-size: 14px;
      border-radius: 2px;
      min-height: 32px;
      @media (max-width: 575px) {
        min-width: 25px;
        height: 25px;
      }

      &.Mui-disabled {
        opacity: 1;
        background-color: #e5e5e63b;
        color: #90a0b7;
        border-radius: 2px;
        border: none;
      }

      &.Mui-selected {
        background-color: #d90429 !important;
        color: #fff !important;
      }
    }
  }
`;
interface CustomTablePaginationProps extends PaginationProps {
  perPage: number | any;
  onChangePerPage?: (e:SelectChangeEvent) => void;
  hasLeftSideSelect?: boolean;
  onChange:any;
}
const PaginationFooter = (props: CustomTablePaginationProps) => {
  const {
    onChange,
    count,
    page,
    perPage,
    onChangePerPage,
    handleChange,
    hasLeftSideSelect,
  } = props;

  return (
    <BottomEntriesPagination direction="row">
      <NoOfPageShwo direction="row">
        {hasLeftSideSelect && (
          <>
            <Typography variant="caption">Show</Typography>
            <FormControl>
              <Select
                id="demo-simple-select"
                value={perPage}
                defaultValue=""
                onChange={onChangePerPage}
                className="selectbg"
                endAdornment={<KeyboardArrowDownIcon />}
              >
                {[10, 20, 50].map((item) => (
                  <MenuItem value={item}>{item}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <Typography variant="caption">
              entries of {count} Pages
            </Typography>
          </>
        )}
      </NoOfPageShwo>
      <PaginationSec className="paginationimgone1">
        <Pagination
          count={count}
          onChange={onChange}
          page={page}
          variant="outlined"
          shape="rounded"
          
        />
      </PaginationSec>
    </BottomEntriesPagination>
  );
};

export default PaginationFooter;
